var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 13.1V22h-4.9v-8.3c0-2.1-.7-3.5-2.5-3.5-1.4 0-2.2 1-2.5 1.9-.1.3-.2.8-.2 1.3V22H7S7.1 8.5 7 7h5l-.1 1.7c.7-1.1 1.8-2.6 4.4-2.6 3.3.1 5.7 2.3 5.7 7zM2.5 0C1 0 0 1.1 0 2.5S1 5 2.5 5 5 3.9 5 2.5 4 0 2.5 0zM0 7h5v15H0z"}));
}

Linkedin.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
